const snakeCase = (str = ''): string =>
  str
    .replace(/[A-Z][a-z]+|[0-9]+|[a-z]+/g, '$& ')
    .split(/\s|-|_/)
    .filter(n => n)
    .map(el => el.toLowerCase())
    .join('_')

export default snakeCase
